import React, { useState, useEffect } from "react";
import { Card, CardTitle, CardBody, Container, Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom"; // Corrected to useNavigate

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const Agents = () => {
  // meta title
  document.title = "Agents";

  // Persistent state for EULA and generation
  const [eulaAccepted, setEulaAccepted] = useState(() => {
    return localStorage.getItem("eulaAccepted") === "true";
  });

  const [isGenerating, setIsGenerating] = useState(false);
  const [isGenerated, setIsGenerated] = useState(() => {
    return localStorage.getItem("isGenerated") === "true";
  });

  const navigate = useNavigate(); // Corrected to useNavigate

  const handleAcceptEULA = () => {
    setEulaAccepted(true);
    localStorage.setItem("eulaAccepted", "true");
  };

  const handleDeclineEULA = () => {
    // Redirect to main page if the user does not agree
    navigate("/");
  };

  const handleGenerateClick = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setIsGenerated(true);
      localStorage.setItem("isGenerated", "true");
    }, 2000); // Simulates generation process
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Agents" breadcrumbItem="Downloads" />

          <Card>
            <CardTitle>Downloads</CardTitle>
            <CardBody>
              <p>
                Click below to generate your custom certificate and binary files for secure downloads. You will receive the details in your registered email address.
              </p>
              <Button 
                color="primary" 
                onClick={handleGenerateClick} 
                disabled={isGenerated || isGenerating}
              >
                {isGenerating ? (
                  <>
                    Generating <Spinner size="sm" style={{ animation: 'spin 3s linear infinite' }}/>
                  </>
                ) : isGenerated ? "Generated ✓" : "Generate Certificate and Binary"}
              </Button>
              {isGenerated && <p className="text-info mt-2">Your certificate and binary have been generated. Please check your email for further details.</p>}
            </CardBody>
          </Card>
        </Container>

        {/* EULA Modal */}
        <Modal isOpen={!eulaAccepted} toggle={() => {}} backdrop="static" keyboard={false}>
          <ModalHeader>End User License Agreement</ModalHeader>
          <ModalBody>
            <h5>Cybersecurity Software EULA</h5>
            <p>
              This End User License Agreement ("EULA") is a legal agreement between you and [Your Company Name]. By using this software, you agree to be bound by the terms outlined below:
            </p>
            <ol>
              <li>
                <strong>License Grant:</strong> You are granted a non-exclusive, non-transferable license to use this software for personal or business purposes.
              </li>
              <li>
                <strong>Prohibited Activities:</strong> You may not reverse engineer, decompile, or disassemble the software, nor use it for any unlawful purposes.
              </li>
              <li>
                <strong>Data Protection:</strong> This software adheres to stringent cybersecurity practices, but you are responsible for ensuring its secure usage in your environment.
              </li>
              <li>
                <strong>Liability:</strong> [Your Company Name] is not liable for any damages resulting from misuse of this software.
              </li>
              <li>
                <strong>Termination:</strong> This agreement is effective until terminated. Violation of any terms will result in immediate termination of your license.
              </li>
            </ol>
            <p>
              By clicking "I Accept," you acknowledge that you have read, understood, and agree to be bound by this EULA.
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleAcceptEULA}>I Accept</Button>
            <Button color="danger" onClick={handleDeclineEULA}>I Decline</Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default Agents;
